const APPLICATION_VARIANT_KEY = 'tamara-checkout-variant'

const getApplicationVariants = () => {
  try {
    const savedValue = window.storage.getItem(APPLICATION_VARIANT_KEY)

    return JSON.parse(savedValue) || {}
  } catch (_) {
    return {}
  }
}

const setApplicationVariants = (variants) => {
  if (!TypeChecker.isObject(variants)) {
    return
  }

  window.storage.setItem(APPLICATION_VARIANT_KEY, JSON.stringify(variants))
}

const removeApplicationVariants = () => {
  window.storage.removeItem(APPLICATION_VARIANT_KEY)
}

export default {
  getApplicationVariants,
  setApplicationVariants,
  removeApplicationVariants,
}
